module.exports = __webpack_public_path__ + "img/resident.d933251e.png";